import Localize from '../../localize';

export default {
  name: 'localize',
  fn: Localize
}